// extracted by mini-css-extract-plugin
export default {"root":"SyDWx7FlvQ","root_active":"xYQKY5ToEK"};